import { WorkflowTrackerKind, WorkflowTrackerStatus } from '@/types/schema';

import { useHouseholdWorkflowTrackersContext } from '../contexts';

const ENTITY_SYNC_WORKFLOW_KINDS_SET: Readonly<Set<WorkflowTrackerKind>> =
  new Set([
    WorkflowTrackerKind.AddeparEntitySync,
    WorkflowTrackerKind.OrionEntitySync,
    WorkflowTrackerKind.EmoneyEntitySync,
    WorkflowTrackerKind.BlackDiamondEntitySync,
    WorkflowTrackerKind.SnowflakeDataSharingSync,
  ]);

/**
 * Reports whether an entity has an active sync in the household's workflow
 * trackers, including syncs started by another user or a system workflow.
 *
 * @param entityId
 */
export function useDoesEntityHaveActiveSync(entityId: string) {
  const tracker = useEntitySyncWorkflowTracker(entityId);

  return (
    tracker?.status === WorkflowTrackerStatus.Queued ||
    tracker?.status === WorkflowTrackerStatus.Started
  );
}

export function useEntitySyncWorkflowTracker(entityId: string) {
  const { trackers } = useHouseholdWorkflowTrackersContext();

  return trackers.find(
    (tracker) =>
      ENTITY_SYNC_WORKFLOW_KINDS_SET.has(tracker.kind) &&
      tracker.entities?.some((entity) => entity.id === entityId)
  );
}
